module.exports = __webpack_public_path__ + "static/img/yu.9e9d4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yu.png
// module id = uEA4
// module chunks = 1